import { useState, useCallback } from 'react';
import { Eye } from 'lucide-react';
import styles from './PhotoStrip.module.css';

interface Photo {
  id: string;
  url: string;
  caption?: string;
}

interface PhotoStripProps {
  photos: Photo[];
  onPhotoPress: (index: number) => void;
}

export function PhotoStrip({ photos, onPhotoPress }: PhotoStripProps) {
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set());

  const handleImageLoad = useCallback((photoId: string) => {
    setLoadedImages(prev => new Set(prev).add(photoId));
  }, []);

  if (photos.length === 0) return null;

  return (
    <div className={styles.container}>
      <p className={styles.hint}>
        <Eye size={14} className={styles.hintIcon} />
        Tap photos to expand
      </p>
      <div className={styles.scrollContainer}>
        {photos.map((photo, index) => {
          const isLoaded = loadedImages.has(photo.id);
          return (
            <button
              key={photo.id}
              className={`${styles.photoButton} ${isLoaded ? styles.loaded : ''}`}
              onClick={() => onPhotoPress(index)}
              aria-label={photo.caption || `Photo ${index + 1}`}
            >
              <img
                src={photo.url}
                alt={photo.caption || `Reference photo ${index + 1}`}
                className={`${styles.photo} ${isLoaded ? styles.photoLoaded : ''}`}
                loading="lazy"
                width={150}
                height={150}
                onLoad={() => handleImageLoad(photo.id)}
              />
              <span className={styles.previewIcon}>
                <Eye size={12} />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

